import { ChangeEventHandler, FC, InputHTMLAttributes, ReactElement } from 'react';
import Button, { ButtonProps } from '../Button';
import { UploadFill } from '@o2/icons';

export interface FileUploadProps {
  /**
   * Element html ID
   */
  id: string;
  /**
   * Text on button
   */
  label: string;
  /**
   * Input name
   */
  name?: string;
  /**
   * Change event handler
   */
  onChange?: ChangeEventHandler;
  /**
   * Icon on button
   */
  icon?: string | ReactElement;
  disabled?: boolean;
  /**
   * Button color
   */
  color?: ButtonProps['color'];
  /**
   * Html input props
   */
  InputProps?: InputHTMLAttributes<HTMLInputElement>;
}

const defaultIcon = <UploadFill />;

/**
 * @deprecated Use `@o2/common-business/FileUploadButton` instead
 */
const FileUpload: FC<FileUploadProps> = ({
  label,
  onChange,
  name,
  id,
  color,
  icon = defaultIcon,
  disabled,
  ...other
}) => {
  return (
    <label htmlFor={id}>
      <input id={id} type="file" name={name} onChange={onChange} hidden disabled={disabled} {...other} />
      <Button color={color} variant="outlined" startIcon={icon} component="span" disabled={disabled}>
        {label}
      </Button>
    </label>
  );
};

export default FileUpload;
